import { defineMessages } from 'react-intl';

export default defineMessages({
  title: 'Add {asset} to your browser wallet',
});
